import { InformationCircleIcon } from '@heroicons/react/24/outline';

export function Notice({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex gap-3 rounded-xl border border-primary-200 bg-primary-50 p-4">
            <InformationCircleIcon
                className="h-5 w-5 shrink-0 text-primary-600"
                aria-hidden="true"
            />
            <p className="text-sm text-raro-gray-700 font-montserrat">{children}</p>
        </div>
    );
}

export default Notice;
